import * as React from 'react'

const SvgSendFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.156 9.444L3.406 2.569a.625.625 0 00-.675.075.625.625 0 00-.206.625l1.656 6.106h7.069v1.25H4.181L2.5 16.712a.625.625 0 00.625.788.625.625 0 00.281-.069l13.75-6.875a.625.625 0 000-1.112z"
      fill="#163250"
    />
  </svg>
)

export default SvgSendFilledIcon
